export { Group } from "@mantine/core";
export type { GroupProps } from "@mantine/core";
